<template>
  <div class="shop-menu-fees main">
    <div class="background" @click="close" />

    <div class="wrapper no-scrollbar">
      <div class="close-wrapper" @click="close">
        <button class="delete is-large" />
      </div>
      <div class="subtitle">{{ $t("menu.fees") }}</div>

      <div class="fee">
        <span class="fee-name">Platform Fee</span>
        <span class="price is-pulled-right">{{ currency }}0</span>
      </div>

      <div class="fee">
        <span class="fee-name">{{ $t("delivery.delivery-fee") }}</span>
        <span class="price is-pulled-right"
          >{{ currency }}{{ deliveryFee }}</span
        >
      </div>

      <div v-if="surge" class="notification is-rain">
        <i class="fa fa-umbrella fa-sm" />&nbsp;
        <span
          >During inclement weather our delivery partners' fees are slightly
          higher due to a driver bonus that goes entirely to each driver on
          successful delivery.</span
        >
      </div>

      <div class="notification">
        <p style="margin-bottom: 8px">
          TUK has already applied a delivery discount to the delivery fee above
          to <i>thank you for supporting local drivers</i>.
        </p>
        <p>
          TUK subsidises the cost of delivery and doesn't charge commissions to
          drivers.
        </p>
      </div>

      <div
        class="button is-fullwidth"
        @click="showCheaperDelivery = !showCheaperDelivery"
      >
        How to get cheaper delivery on TUK&nbsp;<i class="fa fa-chevron-down" />
      </div>

      <div v-if="showCheaperDelivery" class="notification is-white">
        <p class="how-to">(1) Increase order size</p>
        <p class="mb">
          Most shops give automatic delivery discounts for larger orders
        </p>
        <p class="how-to">(2) Order from a closer shop</p>
        <p class="mb">Delivery fees are based on driving distance</p>
        <p class="how-to">(3) Wait a while</p>
        <p>Delivery fees can be higher during inclement weather</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopMenuFees",
  components: {},
  props: {
    deliveryFee: Number,
    currency: String,
    surge: Boolean,
  },
  data() {
    return {
      showCheaperDelivery: false,
    };
  },
  computed: {},
  mounted() {},
  methods: {
    close() {
      this.$toast.clear();
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(128, 128, 128, 0.5);
  z-index: 21;
  backdrop-filter: blur(1px);
}
.background {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
}
.wrapper {
  position: absolute;
  bottom: 0;
  right: 0;
  max-width: 500px;
  height: auto;
  max-height: calc(100vh - 60px);
  overflow: scroll;
  width: 100vw;
  overflow-x: hidden;
  padding: 12px;
  background-color: rgba(255, 255, 255, 0.95);
  text-align: left;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  box-shadow: 0 0 3px #444;
  padding-bottom: 24px;
}
.subtitle {
  font-size: 1.4em;
  font-weight: 500;
  margin-bottom: 12px;
}
.fee {
  padding: 8px;
}
.close-wrapper {
  /* position: absolute; */
  position: fixed;
  /* top: 0; */
  margin-top: -12px;
  right: 0;
  padding: 8px 12px;
  z-index: 2;
}
.required {
  margin-left: 6px;
  font-size: 0.8em;
  font-weight: 500;
  opacity: 0.7;
  background-color: rgba(232, 232, 232);
  border-radius: 3px;
  padding: 3px;
  /* color: red; */
}
.notification {
  margin-top: 8px;
  padding: 6px;
  font-size: 0.85em;
  /* color: grey; */
}
.fee-name {
  font-weight: 450;
  opacity: 0.7;
}
.is-rain {
  background-color: lightblue;
  color: #555;
  font-size: 0.85em;
  margin-bottom: 0;
}
.how-to {
  font-size: 1em;
  font-weight: 450;
}
.mb {
  margin-bottom: 6px;
}
</style>